import DownloadIconWithoutBg from '@/common/assets/icons/DownloadIconWithoutBg.svg?react';
import EditIcon from '@/common/assets/icons/editIcon.svg?react';
import RetakePhotoIcon from '@/common/assets/icons/reTakePhotoIcon.svg?react';
import TrashIcon from '@/common/assets/icons/trashIcon.svg?react';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import EditImage from '@/common/components/imageGallery/components/editImage/EditImage';
import DeleteConfirmationModal from '@/common/components/imageGallery/components/Extensions/deleteConfigration/modal/DeleteConfirmationModal';
import {
  MoreItemsExtensionModalProps,
  MoreItemsProps,
} from '@/common/components/imageGallery/components/Extensions/moreItemsExtension/moreItemsExtension.type';
import useDownloadExtension from '@/common/components/imageGallery/hooks/useDownloadExtension';
import useModal from '@/common/hooks/useModal';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default ({
  closeModal,
  open,
  handleClick,
  items,
  src,
  deleteImageLoading,
}: MoreItemsExtensionModalProps) => {
  return (
    <MainModal closeModal={closeModal} open={open}>
      <MoreItemsModal
        src={src}
        handleClick={handleClick}
        items={items}
        deleteImageLoading={deleteImageLoading}
        closeModal={closeModal}
      />
    </MainModal>
  );
};
const MoreItemsModal = ({
  items,
  handleClick,
  src,
  deleteImageLoading,
  closeModal: moreItemsCloseModal,
}: MoreItemsProps & { closeModal: () => void }) => {
  const { download, loading } = useDownloadExtension({ src });
  const { open, openModal, closeModal } = useModal();
  const {
    open: deleteConfirmationOpen,
    openModal: deleteConfirmationOpenModal,
    closeModal: deleteConfirmationCloseModal,
  } = useModal();
  return (
    <>
      <Flex flexDirection="column" gap="1rem">
        {items.includes('editPhoto') && (
          <Flex
            alignItems="center"
            gap="0.5rem"
            onClick={() => {
              openModal();
            }}
          >
            <Box width="24px">
              <EditIcon className={css({ m: 'auto' })} />
            </Box>
            <Typography>ویرایش</Typography>
          </Flex>
        )}

        {items.includes('retakePhoto') && (
          <Flex
            alignItems="center"
            gap="0.5rem"
            onClick={() => {
              handleClick.retakePhotoOnClick?.();
              moreItemsCloseModal();
            }}
          >
            <Box width="24px">
              <RetakePhotoIcon className={css({ m: 'auto' })} />
            </Box>
            <Typography>عکس برداری مجدد</Typography>
          </Flex>
        )}

        {items.includes('downloadPhoto') && (
          <Flex
            onClick={() => {
              handleClick.downloadPhotoOnClick?.();
              moreItemsCloseModal();
              download();
            }}
            gap="0.5rem"
          >
            {loading ? (
              <Box bgColor="white" borderRadius="8px">
                <CircularLoading width="30" color="colors.purple-primary" />
              </Box>
            ) : (
              <Box width="24px">
                <DownloadIconWithoutBg className={css({ m: 'auto' })} />
              </Box>
            )}
            <Typography>دانلود</Typography>
          </Flex>
        )}

        {items.includes('deletePhoto') && (
          <Flex
            alignItems="center"
            gap="0.5rem"
            onClick={deleteConfirmationOpenModal}
          >
            <Box width="24px">
              <TrashIcon
                stroke={token('colors.red')}
                className={css({ m: 'auto' })}
              />
            </Box>
            <Typography color="red">حذف</Typography>
          </Flex>
        )}
      </Flex>
      {open ? (
        <EditImage
          image={src}
          onClose={closeModal}
          onSave={(data) => {
            handleClick.onEditSuccess?.({ data, closeModal });
            moreItemsCloseModal();
          }}
        />
      ) : null}

      <DeleteConfirmationModal
        open={deleteConfirmationOpen}
        closeModal={deleteConfirmationCloseModal}
        onDeletePhoto={() => {
          handleClick.deletePhotoOnClick?.({
            closeModal: () => {
              deleteConfirmationCloseModal();
              closeModal();
              moreItemsCloseModal();
            },
          });
        }}
        loading={deleteImageLoading}
      />
    </>
  );
};
